import React from 'react';

import { ConfirmDialog } from '@gogame/components';

const FinalizedDialog = ({ onSubmit, onExited, onClose, open }) => {
  return (
    <ConfirmDialog
      title={'Discard unsaved changes?'}
      bodyText={'All plan changes will be lost'}
      confirmActionLabel={'Discard'}
      onSubmit={onSubmit}
      onExited={onExited}
      onClose={onClose}
      open={open}
    />
  );
};

export default FinalizedDialog;
